import React from "react";

const WEBSITE_COLORS = {
  ONLINE: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  OFFLINE: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  DEPLOYING: "bg-blue-500/15 text-blue-300 border-blue-500/30 animate-pulse",
  MAINTENANCE: "bg-orange-500/15 text-orange-300 border-orange-500/30",
  SUSPENDED: "bg-neutral-500/15 text-neutral-300 border-neutral-500/30",
  FAILED: "bg-rose-600/20 text-rose-200 border-rose-500/50",
  UNKNOWN: "bg-slate-500/15 text-slate-300 border-slate-500/30",
};

const HEALTH_COLORS = {
  HEALTHY: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  WARNING: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  CRITICAL: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  UNKNOWN: "bg-slate-500/15 text-slate-300 border-slate-500/30",
};

const SSL_COLORS = {
  VALID: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  EXPIRING_SOON: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  EXPIRED: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  NOT_CONFIGURED: "bg-slate-500/15 text-slate-300 border-slate-500/30",
};

export function WebsiteStatusBadge({ status, size = "md" }) {
  const s = String(status || "UNKNOWN").toUpperCase();
  const cls = WEBSITE_COLORS[s] || WEBSITE_COLORS.UNKNOWN;
  const size_cls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span className={`inline-flex items-center rounded-full border font-black uppercase tracking-wider ${size_cls} ${cls}`}
      data-testid={`website-status-${s.toLowerCase()}`}>{s}</span>
  );
}

export function HealthBadge({ status, size = "md" }) {
  const s = String(status || "UNKNOWN").toUpperCase();
  const cls = HEALTH_COLORS[s] || HEALTH_COLORS.UNKNOWN;
  const size_cls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span className={`inline-flex items-center rounded-full border font-black uppercase tracking-wider ${size_cls} ${cls}`}
      data-testid={`health-status-${s.toLowerCase()}`}>{s}</span>
  );
}

export function SslBadge({ status, size = "md" }) {
  const s = String(status || "NOT_CONFIGURED").toUpperCase();
  const cls = SSL_COLORS[s] || SSL_COLORS.NOT_CONFIGURED;
  const size_cls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span className={`inline-flex items-center rounded-full border font-black uppercase tracking-wider ${size_cls} ${cls}`}
      data-testid={`ssl-status-${s.toLowerCase()}`}>SSL {s.replace("_", " ")}</span>
  );
}
